import { render } from "./CartSidebar.vue?vue&type=template&id=78a1736c&scoped=true"
import script from "./CartSidebar.vue?vue&type=script&lang=js"
export * from "./CartSidebar.vue?vue&type=script&lang=js"

import "./CartSidebar.vue?vue&type=style&index=0&id=78a1736c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a1736c"]])

export default __exports__